var $$ = $$ || {};

$$.Anchors = class Anchors {
	constructor (root) {
		this.root = root;

		this.sectionsPosition = [];

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			anchors: this.root.find('.js-anchor'),
			sections: this.root.find('.js-anchor-section')
		};
	}

	_bindEvents () {
		this.nodes.anchors.on('click', (event) => {
			var anchor = $(event.currentTarget);

			$('html, body').animate({
				scrollTop: $(this.nodes.sections.get(anchor.index())).position().top - 97
			}, 200);
		});

		$$.window
			.on('scroll', _.debounce((event) => {
				var scrollTop = event.currentTarget.scrollY;

				_.forEachRight(this.sectionsPosition, (position, index) => {
					if ( position >= scrollTop ) {
						this.nodes.anchors.removeClass('active');
						$(this.nodes.anchors.get(index)).addClass('active');
					}
				});
			}, 100, {
				leading: true
			}))
			.on('resize', () => this._sectionsPosition())
			.trigger('scroll');
	}

	_ready () {
		this._sectionsPosition();
	}

	_sectionsPosition() {
		this.nodes.sections.each((index, section) => {
			this.sectionsPosition[index] = $(section).position().top + ($$.windowHeight / 2);
		});
	}
};
